/* tslint:disable */
/* eslint-disable */
export enum FilterOperator {
  And = 'And',
  Or = 'Or'
}
